<template>
  <div class="app flex-row align-items-center loginbgnew">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="text-center">
            <img
              class="mb-4"
              src="/images/brand-mark-white_1.svg"
              height="70"
              alt="ux.app Logo"
            />
          </div>
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <form class="row mt-2" @submit.prevent="resetPassWithToken">
                  <div class="form-group col-12 mt-1">
                    <label for="password">New password</label>
                    <input
                      id="password"
                      v-model="user.pass"
                      type="password"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-12 mt-1">
                    <label for="confirm-password">Confirm Password</label>
                    <input
                      id="confirm-password"
                      v-model="user.passConfirm"
                      type="password"
                      class="form-control"
                    />
                  </div>
                  <div class="col-12 mt-2">
                    <button
                      type="submit"
                      class="btn btn-block btn-primary card-submit-button"
                    >
                      Change my password
                    </button>

                    <router-link
                      class="text-muted d-block mt-2 text-center"
                      to="/login"
                    >
                      Back to Login
                    </router-link>
                  </div>
                </form>
              </b-card-body>
            </b-card>
            <!--<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card>-->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordReset',
  data() {
    return {
      token: '',
      user: {
        passConfirm: '',
        pass: ''
      }
    };
  },
  mounted() {
    this.token = this.$route.params.token;
  },
  methods: {
    resetPassWithToken(evt) {
      let $this = this;
      $http
        .post('/api/auth/resetPassword', {
          UserId: this.$route.params.userid,
          ResetToken: this.token,
          Password: this.user.pass
        })
        .then(resp => {
          if (resp.data.success) {
            this.$swal('Password was reset.');
            setTimeout(() => {
              this.$router.push({ name: 'Authentication' });
            }, 1000);
          } else {
            this.$swal('Reset Link is not valid.');
            this.user.pass = '';
          }
        })
        .catch(error => {
          console.log(error);
          this.user.pass = '';
        });
    }
  }
};
</script>

<style scoped></style>
